export const memberCardDetails = [
  {
    id: 1,
    attribute: ['id', 'phone', 'email'],
    label: {
      id: 'User ID',
      phone: 'Phone Number',
      email: 'Interact Email Address',
    },
  },
  {
    id: 2,
    attribute: ['department', 'roleName', 'createdAt'],
    label: {
      createdAt: 'Date Invited',
      roleName: 'Role Name',
      department: 'Department',

    },
  },
  {
    id: 3,
    attribute: ['lastLoggedInAt'],
    label: {
      lastLoggedInAt: 'Last Login',

    },
  },
];
